import { RequestStatus } from "@/requestHooks/common";
import { copyMaterailsOrFolders } from "@/services/createSpace/material";
import { Message } from "@arco-design/web-react";
import { useState } from "react";

interface IUseCopyMaterialsAndFoldersReturn {
  loading: RequestStatus;
  handleCopyFile: (ids: string | string[], project_id: number) => void;
}

const useCopyMaterialsAndFolders = (): IUseCopyMaterialsAndFoldersReturn => {
  const [loading, setLoading] = useState(RequestStatus.NOTREQUESTED);
  const handleCopyFile = async (ids: string | string[], project_id: number) => {
    try {
      setLoading(RequestStatus.LOADING);
      const result = await copyMaterailsOrFolders(ids, project_id);
      setLoading(RequestStatus.SUCCESS);
      Message.success("复制成功！");
      return result;
    } catch (e) {
      setLoading(RequestStatus.FAILED);
      Message.error("复制失败，请刷新后重试!");
    }
  };
  return {
    loading,
    handleCopyFile,
  };
};

export default useCopyMaterialsAndFolders;
